import { render, staticRenderFns } from "./EditReleaseModal.vue?vue&type=template&id=3d88222d"
import script from "./EditReleaseModal.vue?vue&type=script&lang=js"
export * from "./EditReleaseModal.vue?vue&type=script&lang=js"
import style0 from "./EditReleaseModal.vue?vue&type=style&index=0&id=3d88222d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports